import { useEffect } from "react";
import { useMatches } from "react-router";

const SUFFIX = "Sunrise agency";

/**
 * Sets the tab title from the matched route.
 *
 * Every route rendered the same "Sunrise agency", so a row of open tabs was
 * indistinguishable and browser history was a column of one repeated word.
 * The title comes from the route's `handle`, which keeps it next to the path it
 * belongs to rather than scattered through the pages.
 */
export function useDocumentTitle() {
	const matches = useMatches();

	useEffect(() => {
		const titled = [...matches]
			.reverse()
			.find((match) => (match.handle as { title?: string })?.title);
		const title = (titled?.handle as { title?: string })?.title;

		document.title = title ? `${title} · ${SUFFIX}` : SUFFIX;
	}, [matches]);
}
